export default "__VITE_ASSET__BkcxnM5V__"